const Entity = require('./Entity/BaseEntity');

const EntityAttachment = require('./Entity/EntityAttachment');
const EntityContact = require('./Entity/EntityContact');
const EntityDate = require('./Entity/EntityDate');
const EntityMultiSelect = require('./Entity/EntityMultiSelect');
const EntityNPS = require('./Entity/EntityNPS');
const EntityNumeric = require('./Entity/EntityNumeric');
const EntityObject = require('./Entity/EntityObject');
const EntitySingleSelect = require('./Entity/EntitySingleSelect');
const EntityString = require('./Entity/EntityString');
const EntityToggle = require('./Entity/EntityToggle');

Entity.Attachment = EntityAttachment;
Entity.Contact = EntityContact;
Entity.Date = EntityDate;
Entity.MultiSelect = EntityMultiSelect;
Entity.NPS = EntityNPS;
Entity.Numeric = EntityNumeric;
Entity.Object = EntityObject;
Entity.SingleSelect = EntitySingleSelect;
Entity.String = EntityString;
Entity.Toggle = EntityToggle;

module.exports = Entity;
